import { AsyncPipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import { ContentPageId } from '@shared/models/content-page-ids';
import * as fromRootStore from '@store/index';

import { PageComponent } from '../page/page.component';
import { PhoneBlockquoteComponent } from '../phone-blockquote/phone-blockquote.component';

@Component({
  selector: 'app-checklist',
  templateUrl: './checklist.component.html',
  styleUrls: ['./checklist.component.scss'],
  standalone: true,
  imports: [PhoneBlockquoteComponent, AsyncPipe],
})
export class ChecklistComponent extends PageComponent {
  @Input()
  showHeading = true;

  @Input()
  showPhoneNumber = true;

  @Input()
  checklistContentInput = null;

  constructor(globalStore: Store<fromRootStore.State>) {
    super(ContentPageId.shared, globalStore);
  }
}
